import script from "./GroupCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupCard.vue?vue&type=script&setup=true&lang=js"

import "./GroupCard.vue?vue&type=style&index=0&id=49a51422&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49a51422"]])

export default __exports__